"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Cloud, Lock, TrendingUp, Users, Zap, Clock } from "lucide-react";
export default function BenefitsOfCloudAccounting() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const benefits = [{
    icon: Cloud,
    title: "Access Anywhere, Anytime",
    description: "Work from any device with an internet connection—office, home, or on the go."
  }, {
    icon: Lock,
    title: "Bank-Level Security",
    description: "Your financial data is encrypted and stored securely in the cloud with automatic backups."
  }, {
    icon: TrendingUp,
    title: "Real-Time Financial Insights",
    description: "Monitor cash flow, expenses, and profitability with live dashboards and reports."
  }, {
    icon: Users,
    title: "Seamless Collaboration",
    description: "Share data instantly with your accountant, bookkeeper, or team members."
  }, {
    icon: Zap,
    title: "Automatic Updates",
    description: "Always use the latest software version without manual installations or IT support."
  }, {
    icon: Clock,
    title: "Time-Saving Automation",
    description: "Automate invoicing, payroll, and reconciliation to focus on growing your business."
  }];
  return;
}